import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import {
  MultiImageConfigurator,
  Image
} from 'src/components/containers/configurator/MultiImageConfigurator'
import {
  LargeModal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter
} from 'src/components/containers/LargeModal'
import TextArea from 'src/components/atoms/input/TextArea'
import { StoreProps } from 'src/stores'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import { ChangeBtn, TranspBtn } from 'src/components/atoms/input/buttons'

const lastWordsIcon = require('src/assets/configurator/last_words_icon.png')
const speechIcon = require('src/assets/configurator/speech_icon.png')
// const lastWillIcon = require('src/assets/configurator/last_will_icon.png')
const dinnerIcon = require('src/assets/configurator/dinner_icon.png')

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class LastWill extends React.Component<Props> {
  getValueFromStore = (storeId: string, defaultText: string) => {
    const { confStore } = this.props
    const entry = confStore.getDocumentsEntriesByType(storeId)[0]
    return entry && entry.get('data') ? entry.get('data') : defaultText
  }

  getDescription = (storeId: string, fallback: string) => {
    const value = this.getValueFromStore(storeId, fallback)
    if (value.length > 150) return `${value.substring(0, 150)}...`
    return value
  }

  save = (text: string, storeId: string) => {
    const { confStore } = this.props
    const data = new Map()
    data.set('data', text)
    confStore.setDocumentsEntry(storeId, [data])
  }

  render() {
    const { index } = this.props

    return (
      <ConfiguratorBox
        collapsable
        defaultCollapsed
        idLabel={`expand-arrow-last-will`}   
        title={`${index}. Wünsche für meine Bestattung`}>
        <Grid>
          <LastWillRow
            storeId='last_will'
            image={lastWordsIcon}
            title='Meine Abschiedsfeier'
            description={this.getDescription(
              'last_will',
              'Wie soll meine Abschiedszeremonie ablaufen? Was ist mir besonders wichtig?'
            )}
            initialValue={this.getValueFromStore('last_will', '')}
            save={this.save}>
            <div className='product-long-desc'>
              <ul>
                <li>Geben Sie hier an, wie Ihre Bestattung ablaufen soll</li>
                <li>
                  Legen Sie zum Beispiel fest, welchen Ablauf die Zeremonie am
                  Friedhof haben soll
                </li>
              </ul>
            </div>
          </LastWillRow>
          <LastWillRow
            storeId='last_words'
            image={speechIcon}
            title='Meine Rede zum Abschied'
            description={this.getDescription(
              'last_words',
              'Welche Worte sollen bei meiner Bestattung verlesen werden?'
            )}
            initialValue={this.getValueFromStore('last_words', '')}
            save={this.save}>
            <div className='product-long-desc'>
              <ul>
                <li>Verfassen Sie hier Ihre eigene Abschiedsrede</li>
                <li>
                  Bestimmen Sie, welche Worte über Sie auf Ihrer Bestattung
                  verlesen werden sollen
                </li>
              </ul>
            </div>
          </LastWillRow>
          <LastWillRow
            storeId='dinner'
            image={dinnerIcon}
            title='Mein Abschiedsessen'
            description={this.getDescription(
              'dinner',
              'Was soll bei meinem Leichenschmaus serviert werden? Wie soll er ablaufen?'
            )}
            initialValue={this.getValueFromStore('dinner', '')}
            save={this.save}>
            <div className='product-long-desc'>
              <ul>
                <li>
                  Der Leichenschmaus wird oft als wichtiger Bestandteil des
                  Abschieds gesehen
                </li>
                <li>
                  Was soll gegessen werden? Wo soll er stattfinden? Was ist mir
                  besonders wichtig?
                </li>
              </ul>
            </div>
          </LastWillRow>
        </Grid>
      </ConfiguratorBox>
    )
  }
}

interface LastWillProps {
  storeId: string
  image: any
  title: string
  description: string
  save: (text: string, storeId: string) => void
  initialValue: string
  children: any
}

const LastWillRow = (props: LastWillProps) => {
  const {
    save,
    initialValue,
    storeId,
    title,
    description,
    image,
    children
  } = props

  const [value, setValue] = React.useState(initialValue)
  const [modalOpen, setModalOpen] = React.useState(false)

  React.useEffect(() => {
    setValue(initialValue)
  }, [props])

  const hideModal = () => {
    save(value, storeId)
    setModalOpen(false)
  }

  return (
    <>
      <MultiImageConfigurator
        isHighlighted={!!initialValue}
        renderImages={() => {
          return <Image img={image} />
        }}>
        <PriceHeadline id={`${storeId}-ph`} service={title} />
        <TextPreview>{description}</TextPreview>
        <ChangeBtn id={`${storeId}-chbtn`} onClick={() => setModalOpen(true)}>
          {initialValue ? 'Ändern' : 'Verfassen'}
        </ChangeBtn>
      </MultiImageConfigurator>
      <LargeModal animation={false} open={modalOpen} onHide={hideModal}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalContent>
          {children}
          <TextArea
            id={`${storeId}-ta`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            large
            placeholder='Hier können Sie alles festhalten ...'
            style={{ marginTop: 30 }}
          />
        </ModalContent>
        <ModalFooter>
          <TranspBtn onClick={hideModal} id={'save-info-modal'}>Speichern</TranspBtn>
        </ModalFooter>
      </LargeModal>
    </>
  )
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 15px;
  grid-auto-rows: minmax(200px, auto);
`

const TextPreview = styled.p`
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/LastWill.tsx